import React from "react";
import { withLocalize } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import BbFormikCheckbox from "../../styling/bbFormikCheckbox";
import BbCheckbox from "../../styling/bbCheckbox";
import { unicornCountry } from "../../../store/marketingListStore";

class CommonInfo extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="columns is-multiline">
                    <div className="column is-12" style={{ paddingBottom: 0 }}>
                        <div className="bb-chk-grp-all">
                            <BbCheckbox name="all" label={this.props.translate("Charts.CheckAll")} value={this.checkIfAll} id="all" onChange={(c) => this.checkAll(c)} />
                        </div>
                    </div>
                    <div className="column is-6-desktop is-12-tablet" style={{ paddingTop: 0 }}>
                        <React.Fragment>
                            <BbFormikCheckbox name="common.mainNace" label={this.props.translate("Report.Activity.MainNace")} id="nace" />
                            {unicornCountry() === 'sk' && <BbFormikCheckbox name="common.mainNace2" label={this.props.translate("Search.Common.MainNace")} id="nace2" />}
                            <BbFormikCheckbox label={this.props.translate("Search.Common.City")} name="common.city" id="city" />
                            <BbFormikCheckbox label={this.props.translate("Search.Label.Street")} name="common.street" id="street" />
                            <BbFormikCheckbox label={this.props.translate("Search.Address.Zip")} name="common.zip" id="zip" />
                            {unicornCountry() === 'sk' && <BbFormikCheckbox label={this.props.translate("Report.CompanyIdentification.TaxId")} name="common.dic" id="dic" />}
                        </React.Fragment>
                        <React.Fragment>
                            <BbFormikCheckbox label={this.props.translate("Report.CompanyIdentification.VatId")} name="common.icDph" id="icDph" />
                            <BbFormikCheckbox label={this.props.translate("Search.Common.InsertedDate")} name="common.insertedDate" id="insertedDate" />
                            <BbFormikCheckbox label={this.props.translate("Search.Common.DeletedDate")} name="common.deletedDate" id="deletedDate" />
                            <BbFormikCheckbox label={this.props.translate("Search.Identification.Type")} name="common.identType" id="identType" />
                            <BbFormikCheckbox label={this.props.translate("Search.ActivityScope.InstitutionalSector")} name="common.institutionalSector" id="institutionalSector" />
                            <BbFormikCheckbox label={this.props.translate("Search.Common.RegisteredCapital")} name="common.registeredCapital" id="registeredCapital" />

                            <BbFormikCheckbox label={this.props.translate("Search.Common.Phone")} name="common.phone" id="phone" />
                        </React.Fragment>
                    </div>
                    <div className="column is-6-desktop is-12-tablet" style={{ paddingTop: 0 }}>
                        <React.Fragment>
                            <BbFormikCheckbox label={this.props.translate("Search.Common.Mail")} name="common.mail" id="mail" />
                            <BbFormikCheckbox label={this.props.translate("Search.Common.Web")} name="common.web" id="web" />
                            {unicornCountry() === 'cz' && <BbFormikCheckbox label={this.props.translate("Search.Common.DataBox")} name="common.databox" id="databox" />}

                            <BbFormikCheckbox label={this.props.translate("MarketingList.Common.EmployeesCategory")} name="common.employeeCategory" id="employeeCategory" />
                            <BbFormikCheckbox label={this.props.translate("Search.ActivityScope.EmployeesCount")} name="common.employeeCount" id="employeeCount" />
                            <BbFormikCheckbox label={this.props.translate("Search.ActivityScope.Turnover")} name="common.turnover" id="turnover" />
                            <BbFormikCheckbox label={this.props.translate("MarketingList.Common.CourtFileNumber")} name="common.courtFileNumber" id="courtFileNumber" />
                        </React.Fragment>
                        <React.Fragment>
                            {unicornCountry() === 'sk' && <BbFormikCheckbox label={this.props.translate("Search.Common.Section")} name="common.section" id="section" />}
                            <BbFormikCheckbox label={this.props.translate("MarketingList.Common.RegistrationCourt")} name="common.registrationCourt" id="registrationCourt" />
                            {unicornCountry() === 'sk' && <BbFormikCheckbox label={this.props.translate("Search.Common.DistrictOffice")} name="common.districtOffice" id="districtOffice" />}
                            {unicornCountry() === 'sk' && <BbFormikCheckbox label={this.props.translate("Search.Common.PFO.Registry")} name="common.registry" id="registry" />}
                            <BbFormikCheckbox label={this.props.translate("MarketingList.Rating.Semaphore")} name="common.cribisSemaphore" id="cribisSemaphore" />
                            <BbFormikCheckbox label={this.props.translate("Report.Warnings.WarningsInfoActive")} name="common.warningsInfo" id="warningsInfo" />
                        </React.Fragment>
                    </div>

                </div>
            </React.Fragment>
        )
    }
    get checkIfAll() {
        let properties = Object.entries(this.props.formik.values.common).filter(x => typeof x[1] === "boolean");
        let allCount = properties.filter(x => x[0] !== "isChecked").length
        let checkedCount = properties.filter(x => x[0] !== "isChecked" && x[1] === true).length;
        if (checkedCount === 0) { return false };
        if (checkedCount === allCount) { return true };
        return null;
    }
    checkAll(value) {
        let newState = Object.assign({}, this.props.formik.values.common);
        Object.keys(newState).filter(x => typeof newState[x] === "boolean").map((c) => {
            newState[c] = value;
        });
        this.props.formik.setFieldValue("common", newState);
    }
}

export default withLocalize(connectFormik(CommonInfo))


